
import { defineComponent, inject, ref, reactive, onMounted, watch } from "vue";
import { getOrderTable, postOrderWriteOff } from "@/api/http";
import { column } from "@/assets/types/common";
import { validateInput } from "@/assets/js/formRules";
import { Request } from "@/api/request";

type screen = {
    search: string;
    time: Array<string> | null;
    service: Array<number> | null;
};
type screenKey = keyof screen;
type order = {
    ordersn: string;
    create_time: string;
    project: string;
    classifcation: string;
    goodsprice: string;
    user_id: string;
    phone: number | null;
    pay_status_text: string;
    nucleus_pin_code: string;
    nucleus_pin_code_status: number;
    id: number;
};
const columnList: Array<column> = [
    {
        prop: "id",
        label: "排序",
        width: 180,
    },
    {
        prop: "level_title",
        label: "会员等级",
        width: 164,
    },
    {
        prop: "level_name",
        label: "等级名称",
        width: 80,
    },
    {
        prop: "upgrade_price",
        label: "升级金额",
        width: 80,
    },
  
];
const orderStatusNav: Array<{ name: string; id: number | string }> = [
    {
        name: "待审核",
        id: 0,
    },
    {
        name: "待打款",
        id: 1,
    },
    {
        name: "已打款",
        id: 2,
    },
];
export default defineComponent({
    name: "LevelList",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["会员管理", "会员权益"]);
        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            loading = ref(true),
            dialog_model = ref(''),
            screen = ref({
                search: "",
                time: null,
                service: null,
            } as screen),
            orderStatus = ref(0),
            screenParameter: any =ref( {
                page: currentPage.value,
                pagesize: pageSize.value,
                admin_status: orderStatusNav[orderStatus.value].id,
                type: 1
            } as any),
            shortcuts = ref([
                {
                    text: "最近一周",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        return [start, end];
                    })(),
                },
                {
                    text: "最近一个月",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        return [start, end];
                    })(),
                },
                {
                    text: "最近三个月",
                    value: (() => {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        return [start, end];
                    })(),
                },
            ]),
            project = ref([]),
            form = ref({} as any),
            dialogFormVisible = ref(false),
            orderDetail = ref({} as order),
            dialogNavIndex = ref(0),
            _edit = (i:number) => {
                dialog_model.value = 'edit'
                form.value = {
                    level_id:　tableData.value[i].id,
                    level_name: tableData.value[i].level_name,
                    level_title: tableData.value[i].level_title,
                    upgrade_price: tableData.value[i].upgrade_price,
                    order: tableData.value[i].order,
                    status: 1
                }

                console.log(form.value)
            },
            _add = () => {
                dialog_model.value = 'add'
                form.value = {
                    level_name:'',
                    level_title: '',
                    upgrade_price: '',
                    order: '',
                }
            },
            _back = (level_id: number) => {
                dialog_model.value = 'back'

                Request.axiosInstance({
                    url: 'adminapi/UserLevel/backInfo',
                    data: {level_id}
                }).then((res: any) => {
                    form.value = res?.content?.list
                })
                
            },
            _payment = (id:number) => {
                Request.axiosInstance({
                    url: 'adminapi/Withdrawal/payment',
                    data: {id}
                }).then((res:any) => {
                    res.status == 202 && getTableData()
                })
            },
            _withdrawalAudit = (id:number, status: number) => {
                Request.axiosInstance({
                    url: 'adminapi/Withdrawal/withdrawalAudit',
                    data: {id, status}
                }).then((res:any) => {
                    res.status == 202 && getTableData()
                })
            },
            _onsubmit = () => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (!valid) return 
                    Request.axiosInstance({
                        url: dialog_model.value == 'edit' ? 'adminapi/UserLevel/edit' :
                            dialog_model.value == 'add' ?'adminapi/UserLevel/create': 'adminapi/UserLevel/backSave',
                        data: dialog_model.value != 'back'? form.value : {list: form.value}
                    }).then((res) => {
                        if(res.status != 202) return

                        dialog_model.value = ''
                        getTableData();
                        
                    });
                    
                });
            },
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("请输入核销码", value, callback);
                        },
                        trigger: "change",
                    },
                ],
            }),
            formRef = ref(null);

        let getTableData = () => {
                loading.value = true;
                screenParameter.value.status = orderStatusNav[orderStatus.value].id
                Request.axiosInstance({
                    url: 'adminapi/UserLevel/LevelList',
                    data: screenParameter.value
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    project.value = res?.content?.project || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                });
            },
            handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            },
            selectChange = (
                e: string | Array<Date> | Array<number>,
                key: screenKey
            ): void => {
                if (!e) {
                    if (key == "service") {
                        delete screenParameter["project_type_pid"];
                        delete screenParameter["project_id"];
                    } else if (key == "time") {
                        delete screenParameter["start_time"];
                        delete screenParameter["end_time"];
                    } else {
                        delete screenParameter[key];
                    }
                } else {
                    if (key == "service") {
                        screenParameter["project_type_pid"] = e[0];
                        screenParameter["project_id"] = e[1];
                    } else if (key == "time") {
                        screenParameter["start_time"] =
                            (e[0] as Date).getTime() / 1000;
                        screenParameter["end_time"] =
                            (e[1] as Date).getTime() / 1000;
                    } else {
                        screenParameter[key] = e;
                    }
                }
                getTableData();
            },
            columnChange = (item: order, index: number) => {
               dialogFormVisible.value = true;
               orderDetail.value = item;
                dialogNavIndex.value = index;
            },
            check = (): void => {
                (formRef.value as any).validate((valid: boolean) => {
                    console.log(valid);
                    if (valid) {
                        postOrderWriteOff({
                            order_id: orderDetail.value.id,
                            nucleus_pin_code:
                                orderDetail.value.nucleus_pin_code,
                        }).then((res) => {
                            if (res.status == 202) {
                                orderDetail.value.pay_status_text = "已完成";
                                orderDetail.value.nucleus_pin_code_status = 1;
                                getTableData();
                            }
                        });
                    }
                });
            };
        onMounted(() => {
            getTableData();
        });
        watch(orderStatus, (newValue, oldValue) => {
          screenParameter.status = orderStatusNav[newValue].id
            getTableData();
        });
        return {
            headClass,
            columnList,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            orderStatusNav,
            orderStatus,
            screen,
            shortcuts,
            project,
            dialogFormVisible,
            orderDetail,
            dialogNavIndex,
            rules,
            formRef,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            columnChange,
            check,
            screenParameter,
            _payment,
            _withdrawalAudit,
            dialog_model,
            _edit,
            _add,
            form,
            _onsubmit,
            _back
        };
    },
    mounted () {
       
    },
    methods:{
        a () {
            // (this.print as any).click()
            //  (this as any).$print(this.print)
        }
    }
});
